The identifier for the `HiringOrganization` that owns the position opening.

This is typically a hirer,
but may be a recruitment agency for position openings created outside of the SEEK API.
